import { Trans, useTranslation } from 'react-i18next'
import styled from '@emotion/styled'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useRouting } from 'src/routes'
import { RelativeLink } from 'src/system/ui/link/RelativeLink'
import type { UserFieldsFragment as User } from 'src/graphql/types'

// A steam-linked user whose automatch is inactive (no Steam game auth code) is
// not getting their Valve / CS2 official matches auto-downloaded — surface the
// warning. This is the same edge case the route gate lets through when the user
// is also FACEIT-linked.
export function shouldShowValveAutoDownloadWarning(
  user: User | null | undefined
): boolean {
  return Boolean(user?.isAccountLinked && !user.automatch.isActive)
}

export function ValveAutoDownloadWarning() {
  const { t } = useTranslation()
  const { routes } = useRouting()

  return (
    <Box>
      <Title>
        <FontAwesomeIcon icon={faExclamationTriangle} />{' '}
        {t('matches:valve_auto_download_warning:title')}
      </Title>
      <Description>
        <Trans i18nKey='matches:valve_auto_download_warning:body'>
          {' '}
          <RelativeLink to={routes.account}> </RelativeLink>
        </Trans>
      </Description>
    </Box>
  )
}

const Box = styled.div`
  margin-top: ${(props) => props.theme.d.spacing[2]};
  margin-bottom: ${(props) => props.theme.d.spacing[4]};
  padding: ${(props) =>
    `${props.theme.d.spacing[2]} ${props.theme.d.spacing[4]}`};
  border: 1px solid ${(props) => props.theme.d.colors.warning};
  border-radius: 4px;
`

const Title = styled.h3`
  color: ${(props) => props.theme.d.colors.warning};
  font-weight: bold;
  font-size: 14px;
  margin: 0;
`

const Description = styled.p`
  margin: ${(props) => `${props.theme.d.spacing[2]} 0 0`};
  font-size: 13px;
`
